import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async createActivityCategory({ commit }, payload) {
    return Vue.axios.post(Vue.$url("activity-category"), payload)
      .then((rsp) => {
        Vue.$log.debug("actvity category created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'ActivityCategory', 1: payload.description }), { root: true });
      })
  },

  async fetchNextMaxCode({ commit }) {
    return Vue.axios.get(Vue.$url("activity-category/max-code"))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data)
        return rsp.data;
      })
  },

  async fetchActivityCategories({ commit }, active = -1) {
    let query = "?isDel=" + (active == -1 ? '' : !active);
    return Vue.axios.get(Vue.$url("activity-category" + query))
      .then((rsp) => {
        commit("SET_ACTIVITY_CATEGORIES", rsp.data);
      })
  },

  async deleteActivityCategory({ commit }, payload) {
    Vue.$log.debug('trying to delete activity category', payload.id);
    return Vue.axios.delete(Vue.$url("activity-category/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      });
  },

  async updateActivityCategory({ commit }, payload) {
    return Vue.axios.put(Vue.$url("activity-category/" + payload.id), payload)
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'ActivityCategory', 1: payload.description }), { root: true });
      })
  },
}